function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.8 15.6a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0zM11.21 7.86a.8.8 0 011.58 0l.01.14v4l-.01.14a.8.8 0 01-1.58 0L11.2 12V8l.01-.14z",
  fill: "#FF5959"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm-1.6 0a6.4 6.4 0 10-12.8 0 6.4 6.4 0 0012.8 0z",
  fill: "#FF5959"
})));